<template>
    <desk-global id="app">
        <template #header>
            <desk-header />
        </template>

        <desk-main />
    </desk-global>
</template>

<script>
import DeskHeader from '@/views/components/desk-header';
import DeskMain from '@/views/components/desk-main';
import DeskGlobal from '@/views/components/desk-global';

export default {
    name: 'Desk',
    components: {
        DeskGlobal,
        DeskMain,
        DeskHeader
    }
};
</script>

<style lang="scss">
@import '../styles/var';

#first-loading {
    display: none;
}
</style>
